import PropTypes from 'prop-types';
import React from 'react';
import events from '../../../lib/events.js';

class RadioGroup extends React.PureComponent {
  static displayName = 'RadioGroup';

  static propTypes = {
    inline: PropTypes.bool,
    keys: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    dataKey: PropTypes.string.isRequired,
    colSizes: PropTypes.array,
    onClick: PropTypes.func,
    groupName: PropTypes.string,
  };

  componentDidMount() {
    // Re-render on hash change so active takes effect
    this.listener = events.subscribe('radioHaschange', () => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    if (this.listener && this.listener.remove) {
      this.listener.remove();
    }
  }

  getInitialProps = () => {
    return {
      inline: false,
      keys: this.props.options,
    };
  };

  handleChange = (e) => {
    if (this.props.dataKey && this.props.onChange && !this.props.onClick) {
      this.props.onChange({key: this.props.dataKey, value: e.target.dataset.value});
    }
  };

  handleClick = (e) => {
    if (this.props.dataKey && this.props.onClick) {
      e.stopPropagation();
      this.props.onClick({key: this.props.dataKey, value: e.target.dataset.value});
    }
  };

  render() {
    let {keys, options, value, inline, colSizes, groupName} = this.props;
    let name = new Date().toString();

    if(groupName) {
      name = `${groupName}-${name}`;
    }

    keys = keys || options;

    let radios = keys.map((x, i) => <label key={i}>
      <input type='radio' name={name} data-value={x} checked={value === x} onChange={this.handleChange} onClick={this.handleClick}/>
      &nbsp;{options[i]}
    </label>);

    if (inline) {
      radios = radios.map((x, i) => <div key={`radio-${i}`} className={`col-xs-${colSizes ? colSizes[i] : 12 / radios.length}`}>{x}</div>);
    }

    return <div className='radio-group'>
      {radios}
    </div>;
  }
}

export default RadioGroup;
